function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, String) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "attrs": {
          'testref': `menuItems`
        },
        "class": {
          'mp-control-bar': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = ($attr(`controls`));
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, control, index) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                const {
                  disabled,
                  icon,
                  label,
                  theme,
                  value,
                  slot,
                  tooltip
                } = control;;
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-control-bar-control': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((tooltip) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                      "attrs": tooltip,
                    }, [__vjadeSafeCode(tooltip.text)]));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat((slot) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("slot", {
                      "attrs": {
                        name: slot
                      },
                    }));;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-button", {
                      "key": `${index}-value`,
                      "attrs": {
                        disabled,
                        icon,
                        value,
                        size: $attr(`size`),
                        theme: theme || $attr(`theme`),
                      },
                      "on": {
                        click: $helpers.handleClick
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((label) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(label);;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var index = $$objKey;
                if ($$obj.hasOwnProperty(index)) {
                  $$iterated = true;
                  var control = $$obj[index];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    const {
                      disabled,
                      icon,
                      label,
                      theme,
                      value,
                      slot,
                      tooltip
                    } = control;;
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-control-bar-control': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((tooltip) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": tooltip,
                        }, [__vjadeSafeCode(tooltip.text)]));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      __jade_nodes = __jade_nodes.concat((slot) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("slot", {
                          "attrs": {
                            name: slot
                          },
                        }));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "key": `${index}-value`,
                          "attrs": {
                            disabled,
                            icon,
                            value,
                            size: $attr(`size`),
                            theme: theme || $attr(`theme`),
                          },
                          "on": {
                            click: $helpers.handleClick
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((label) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(label);;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());
        const overflowItems = $helpers.getOverflowItems();;
        __jade_nodes = __jade_nodes.concat((overflowItems.length) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-control-bar-truncated-menu-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": {
                'theme': `tertiary`,
                'button-theme': $attr(`theme`),
                'menu-alignment': $attr(`overflow-menu-alignment`),
                'tooltip': JSON.stringify($helpers.getContextualOverflowTooltip()),
                'icon': JSON.stringify({
                  leftIcon: $attr(`overflow-icon`),
                }),
                'sections': JSON.stringify(overflowItems),
                'menu-width': $attr(`overflow-menu-width`),
                'testref': `overflowMenu`,
              },
              "on": {
                change: $helpers.handleMenuClick,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;